import { styled, Typography } from '@mui/material';

export const FrameRangeSelectorLabel = styled(Typography)`
  font-weight: 500;
`;
